<template>
    <div class="container">
        <div class="spacer responsive-small logo-container"></div>
        <div class="activation-area">
            <div class="spacer responsive-large logo-container"></div>
                <activation-form v-if="!UnsupportedBrowser" @Activate="onActivate" v-show="!isLoading && !isFailed"/>
                <loading v-if="!UnsupportedBrowser" v-show="isLoading && !isFailed" :status="CurrentStatus"/>
                <failed v-if="!UnsupportedBrowser" v-show="isFailed" :status="FailureReason"/>
                <unsupported-browser v-if="UnsupportedBrowser" />
            <div class="spacer responsive-large"></div>
        </div>
    </div>
</template>

<script>
import ActivationForm from "./ActivationForm.vue";
import Loading from "./Loading.vue";
import Failed from "./Failed.vue";
import UnsupportedBrowser from "./UnsupportedBrowser.vue"
import axios from "axios";
import { setTimeout } from "timers";
// import { hostname } from 'os';

export default {
    name: "InputBar",
    components: {
        ActivationForm,
        Loading,
        Failed,
        UnsupportedBrowser
    },
    data() {
        return {
            isLoading: false,
            isFailed: false,
            interval: null,
            systemId: "",
            pin: "",
            CurrentStatus: "",
            StartupCount: 0,
            LoadingRetryCount: 0,
            MaxLoadingRetryCount: 10,
            FailureReason: "Activation failed..."
        };
    },
    methods: {
        onActivate(activationData) {
            console.log("InputActivate");
            console.log(activationData);
            if (activationData.systemId == "") {
                alert("Please enter a system Id.");
            } else if (activationData.pin == "") {
                alert("Please enter a valid PIN");
            } else {
                this.systemId = activationData.systemId;
                this.pin = activationData.pin;
                this.CurrentStatus = "Validating";
                this.StartupCount = 0;
                this.LoadingRetryCount = 0;
                this.startUpdates();
            }
        },
        startUpdates() {
            console.log("StartUpdates");
            this.isLoading = true;
            this.onUpdateStatus();
        },
        stopUpdates() {
            this.systmId = "";
            this.pin = "";
            this.isLoading = false;
        },
        showFailureNotice() {
            setTimeout(() => {
                this.isFailed = false;
            }, 4000);
            this.isFailed = true;
            this.isLoading = false;
        },
        onUpdateStatus() {
            console.log("onUpdateStatus");
            if (this.systemId == "" || this.pin == "") {
                this.showFailureNotice();
            } else if (this.isLoading) {
                this.LoadingRetryCount++
            
                if(this.LoadingRetryCount > this.MaxLoadingRetryCount) {
                    vm.stopUpdates();
                    vm.showFailureNotice();
                }
                else {
                    var vm = this;
                    let uri = `${process.env.VUE_APP_ROOT_API}`;
                    console.log(uri);
                    console.log(`Attempt: ${vm.LoadingRetryCount} of ${vm.MaxLoadingRetryCount}`)

                    var config = {}; // Emulater returns 404 if auth header is included in the request

                    axios.post(
                        uri,
                        { systemId: this.systemId, pin: this.pin },
                        config
                    )
                    .then(function(result) {
                        console.log(String(result.data.value).toUpperCase());
                        switch (String(result.data.value).toUpperCase()) {
                            case "POWERSTATE/RUNNING":
                                var redirectUri = null
                                vm.CurrentStatus = "Waiting for service start...";
                                try {
                                    console.log(`Result: ${result.data}`)
                                    var url = new URL(result.data.portalUri)
                                    console.log(`Redirect: ${url}`)
                                    var validHosts = process.env.VUE_APP_VALID_REDIRECT_HOSTS.split(";")
                                    var validCount = validHosts.filter(value => url.hostname.match(value.replace(".", "\.").replace("*", "."))).length
                                    if (validCount > 0) {
                                        redirectUri = result.data.portalUri
                                    }
                                    else {
                                        vm.FailureReason = "Portal redirect URL is not in the approved list."
                                        vm.showFailureNotice();
                                        return;
                                    }
                                }
                                catch {
                                    vm.FailureReason = "Invalid or undefined portal redirect URL"
                                    vm.showFailureNotice();
                                    return;
                                }

                                // system is running and portal uri is valid. Delay a bit (less if it was running on
                                // the first check) to allow the RDP service to start then redirect to logon page
                                console.log("redirect to: " + redirectUri)
                                setTimeout( (vm, redirectUri) => window.location.href = redirectUri, vm.StartupCount == 0 ? 4000 : 30000, vm, redirectUri); 
                                return;

                            case "POWERSTATE/DEALLOCATING":
                            case "POWERSTATE/STOPPING":
                                vm.CurrentStatus = "Waiting for deactivation in progress...";
                                break;

                            case "POWERSTATE/DEALLOCATED":
                            case "POWERSTATE/STOPPED":
                            case "POWERSTATE/STARTING":
                                vm.CurrentStatus = "Activating...";
                                break;

                            default:
                                vm.CurrentStatus = String(
                                    result.data.value
                                ).replace("PowerState/", "");
                        }
                        setTimeout(vm.onUpdateStatus, 5000); // Call self to update status after delay
                    })
                    .catch(function(error) {
                        if (error.response) {
                            if (error.response.status === 401) {
                                vm.apiToken = null;
                            }
                        }
                        vm.stopUpdates();
                        vm.showFailureNotice();
                    });
                }
            }
        }
    },
    computed: {
        UnsupportedBrowser() {
            if(window.navigator.userAgent.match("Trident/|MSIE"))
            {
                console.log("MSIE")
                return true;
            }
        
            console.log("Supported")
            return false;
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.activation-area {
    display: table;
    width: 100%;
    min-height: 160px;
    text-align: center;
    background-color: rgba(14, 56, 55, 0.9);
}

.loadstatus {
    height: 50px;
    color: #fff;
}

.spacer {
    display: table-cell;
    height: 160px;
    min-width: 280px;
}

.responsive-small {
    display: none;
}

.logo-container {
    background-image: url(../assets/ns_gateway_logo_center.png);
    background-repeat: no-repeat;
    background-position: center;
}

@media (max-width: 1009px) {
    .responsive-small {
        display: block;
    }

    .responsive-large {
        display: none;
    }
}

@media (max-width: 610px) {
    .right {
        float: none;
        position: relative;
    }

    .left {
        float: none;
        position: relative;
    }

    .credentialform input {
        width: 100%;
        font-size: 16px;
        padding-left: 10px;
        color: #87898b;
        left: 0;
    }

    .button.logon {
        width: 100%;
    }

    .credentialform {
        width: 100%;
    }

    .logon-form-area {
        padding-left: 40px;
        padding-right: 40px;
    }
}

@media (max-height: 660px) {
    .logo-container {
        transform: scale(0.75);
        height: 100px;
    }
}

@media (max-height: 331px) {
    .logo-container {
        display: none;
    }
}
</style>
